import { createSlice } from '@reduxjs/toolkit';
import { DROPDOWN_LIST_NONE } from '../common/common';

const defaultItem = { id: DROPDOWN_LIST_NONE, name: DROPDOWN_LIST_NONE };

const initialState = {
  exchanges: [defaultItem],   // [{ id: 'XTSX', name: 'XTSX' }]
  markets: [defaultItem],     // [{ id: 'EQ', name: 'Equities' }]
  instruments: [defaultItem],  // [{ id: 'AAPL', name: 'Apple Inc.' }]
  holdings: [defaultItem],  // all holdings type ie currences, stocks, crypto for holdings drop down
  accounts: [defaultItem],  // all trading accounts 
  trading_rules: [defaultItem],  // all trading rules
  trading_users: [defaultItem],  // all trading users
  engine_users: [defaultItem]  // all engine users
};

const dropDownSlice = createSlice({
  name: 'dropDown',
  initialState,
  reducers: {
    // === SETTERS (replace entire list) ===
    setExchanges: (state, action) => {
      state.exchanges = action.payload;
    },
    setMarkets: (state, action) => {
      state.markets = action.payload;
    },
    setInstruments: (state, action) => {
      state.instruments = action.payload;
    },
    setHoldings: (state, action) => {
      state.holdings = action.payload;
    },
    setAccounts: (state, action) => {
      state.accounts = action.payload;
    },
    setTradingRules: (state, action) => {
      state.trading_rules = action.payload;
    },
    setTradingUsers: (state, action) => {
      state.trading_users = action.payload;
    },
    setEngineUsers: (state, action) => {
      state.engine_users = action.payload;
    },

    // === ADD UNIQUE ITEMS ===
    addExchange: (state, action) => {
      const exists = state.exchanges.some(ex => ex.id === action.payload.id);
      if (!exists) state.exchanges.push(action.payload);
    },
    addMarket: (state, action) => {
      const exists = state.markets.some(m => m.id === action.payload.id);
      if (!exists) state.markets.push(action.payload);
    },
    addInstrument: (state, action) => {
      const exists = state.instruments.some(inst => inst.id === action.payload.id);
      if (!exists) state.instruments.push(action.payload);
    },
    addHoldings: (state, action) => {
      const exists = state.holdings.some(inst => inst.id === action.payload.id);
      if (!exists) state.holdings.push(action.payload);
    },
    addAccounts: (state, action) => {
      const exists = state.accounts.some(inst => inst.id === action.payload.id);
      if (!exists) state.accounts.push(action.payload);
    },
    addTradingRules: (state, action) => {
      const exists = state.trading_rules.some(inst => inst.id === action.payload.id);
      if (!exists) state.trading_rules.push(action.payload);
    },
    addTradingUsers: (state, action) => {
      const exists = state.trading_users.some(u => u.id === action.payload.id);
      if (!exists) state.trading_users.push(action.payload);
    },
    addEngineUsers: (state, action) => {
      const exists = state.engine_users.some(u => u.id === action.payload.id);
      if (!exists) state.engine_users.push(action.payload);
    }
  }
});

export const {
  setExchanges,
  setMarkets,
  setInstruments,
  setHoldings,
  setAccounts,
  setTradingRules,
  setTradingUsers,
  addExchange,
  addMarket,
  addInstrument,
  addHoldings,
  addAccounts,
  addTradingRules,
  addTradingUsers,
  addEngineUsers
} = dropDownSlice.actions;

// === SELECTORS ===
export const selectExchanges = (state) => state.dropDown.exchanges;
export const selectMarkets = (state) => state.dropDown.markets;
export const selectInstruments = (state) => state.dropDown.instruments;
export const selectHoldings = (state) => state.dropDown.holdings;
export const selectAccounts = (state) => state.dropDown.accounts;
export const selectTradingRules = (state) => state.dropDown.trading_rules;
export const selectTradingUsers = (state) => state.dropDown.trading_users;
export const selectEngineUsers = (state) => state.dropDown.engine_users;

export default dropDownSlice.reducer;
